// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__PPQ9l","select":"styles_select__XjmIG"};